// extracted by mini-css-extract-plugin
module.exports = {"secondary-font":"Work Sans","main-dark":"#131313","button":"nav-button_button__8SQj7","primary":"nav-button_primary__Ok2wN","secondary":"nav-button_secondary__wvh3V"};